<template>
    <div id="app">
        <hero :scrollPos="scrollPos"/>
        <div id="hero"></div>
        <navigation :propWidth="propWidth" :propHeight="scrollPos" :propPos="hero"/>
        <div class="bg-hero">
            <information-section :propScroll="scrollPos" :propPos="hero"/>
            <about-us></about-us>
        </div>
        <references class="references"/>
        <contact/>
        <tender/>
        <!--<partners/>-->
        <Footer></Footer>
        <modalz></modalz>
        <ref-modalz></ref-modalz>
    </div>
</template>

<script>
import '@/assets/styles/main.css'
import Hero from './components/Hero.vue'
import Navigation from './components/Navigation.vue'
import InformationSection from './components/InformationSection.vue'
import AboutUs from './components/Aboutus.vue'
import References from './components/References.vue'
import Contact from './components/Contact.vue'
import Tender from './components/Tender.vue'
import Partners from './components/Partners.vue'
import Footer from './components/Footer.vue'
import Modalz from './components/Modalz'
import RefModalz from './components/RefModalz'

export default {
  components: {Hero, InformationSection, References, Contact, Partners, Footer, Navigation, Modalz, AboutUs, Tender, RefModalz},
  data () {
    return {
      scrollPos: 0,
      hero: this.getOffset,
      propWidth: window.innerWidth
    }
  },
  methods: {
    handleScroll () {
      this.scrollPos = window.pageYOffset
    },
    handleResize () {
      this.propWidth = window.innerWidth
      this.hero = this.getOffset()
    },
    getOffset () {
      return document.getElementById('hero').offsetTop
    }
  },
  mounted: function () {
    this.hero = this.getOffset()
  },
  created: function () {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleResize)
  },
  destroyed: function () {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleScroll)
  }
}
</script>
<style>
    .bg-hero {
        background-color: #ffffff;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%23395288' fill-opacity='0.1'%3E%3Cpath opacity='.5' d='M96 95h4v1h-4v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9zm-1 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9z'/%3E%3Cpath d='M6 5V0H5v5H0v1h5v94h1V6h94V5H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");    }
</style>



// WEBPACK FOOTER //
// src/App.vue